(function () {
  const LATIN = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const OTHER = '#';

  function readPayload(scope) {
    const node = scope.querySelector('[data-salut-brands]');
    return node ? JSON.parse(node.textContent) : { pages: 1, brands: [] };
  }

  function pageFetcher(sectionUrl) {
    return (page) => window.SalutMmenuLazy.fetchSection(sectionUrl + '&page=' + page)
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (!doc.querySelector('[data-salut-brands]')) throw new Error('payload');
        return readPayload(doc).brands;
      });
  }

  function anchorId(prefix, letter) {
    return prefix + (letter === OTHER ? 'other' : letter);
  }

  function currentLanguage() {
    return document.documentElement.lang.startsWith('ru') ? 'ru' : 'ro';
  }

  function buildLetters(known, present, prefix) {
    const alphabet = known.has(OTHER) ? [OTHER].concat(LATIN) : LATIN;
    return alphabet.map((letter) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'salut-mmenu-brands__letter';
      button.textContent = letter;
      button.disabled = !present.has(letter);
      button.dataset.scrollTo = anchorId(prefix, letter);
      return button;
    });
  }

  function buildRow(template, brand, lang) {
    const row = template.content.firstElementChild.cloneNode(true);
    let link = row.querySelector('a');
    if (brand.count > 0) {
      link.href = brand.url;
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = link.className;
      placeholder.append(...link.childNodes);
      link.replaceWith(placeholder);
      link = placeholder;
      row.classList.add('is-empty');
    }
    link.querySelector('.salut-menu-row__title').textContent = brand.title;
    link.querySelector('.salut-menu-row__count').textContent = window.SalutMenuLogic.formatCount(brand.count, lang);
    return row;
  }

  function buildGroup(template, group, lang, prefix) {
    const section = document.createElement('section');
    section.className = 'salut-mmenu-brands__group';
    section.id = anchorId(prefix, group.letter);
    const heading = document.createElement('h4');
    heading.className = 'salut-mmenu-brands__group-title';
    heading.textContent = group.letter;
    const list = document.createElement('ul');
    list.className = 'salut-mmenu-brands__rows';
    list.setAttribute('role', 'list');
    list.append(...group.items.map((brand) => buildRow(template, brand, lang)));
    section.append(heading, list);
    return section;
  }

  function render(screen, brands, query, prefix) {
    const root = screen.querySelector('[data-salut-brands-root]');
    if (!root) return;
    const logic = window.SalutMenuLogic;
    const lang = currentLanguage();
    const list = root.querySelector('[data-salut-brand-list]');
    const letters = root.querySelector('[data-salut-brand-letters]');
    const message = root.querySelector('[data-salut-brand-message]');
    const template = root.querySelector('template[data-salut-brand-row]');
    const filtered = logic.filterBrands(brands, query);
    const groups = logic.groupBrands(filtered, lang);
    const known = new Set((filtered === brands ? groups : logic.groupBrands(brands, lang)).map((group) => group.letter));
    const present = new Set(groups.map((group) => group.letter));

    root.dataset.empty = String(brands.length === 0);
    letters.replaceChildren(...buildLetters(known, present, prefix));
    list.replaceChildren(...groups.map((group) => buildGroup(template, group, lang, prefix)));
    list.removeAttribute('aria-busy');

    const text = brands.length === 0 ? root.dataset.emptyText : root.dataset.noMatchText;
    message.hidden = groups.length > 0;
    message.textContent = groups.length > 0 ? '' : text;
  }

  function collect(screen, fetchPage) {
    return Promise.resolve()
      .then(() => {
        const first = readPayload(screen);
        const rest = [];
        for (let page = 2; page <= first.pages; page += 1) rest.push(fetchPage(page));
        return Promise.all(rest).then((pages) => first.brands.concat(...pages));
      });
  }

  function mount(screen, sectionUrl, prefix) {
    if (!window.SalutMenuLogic) return Promise.reject(new Error('logic'));
    screen.dataset.brandsReady = 'pending';
    return collect(screen, pageFetcher(sectionUrl))
      .then((brands) => {
        const input = screen.querySelector('[data-salut-brand-filter]');
        render(screen, brands, '', prefix);
        input.addEventListener('input', () => render(screen, brands, input.value, prefix));
        screen.dataset.brandsReady = 'true';
      })
      .catch((error) => {
        delete screen.dataset.brandsReady;
        throw error;
      });
  }

  document.addEventListener('salut-mmenu:loaded', (event) => {
    const screen = event.target;
    if (!screen.matches || !screen.matches('[data-screen="brands"]') || screen.dataset.brandsReady) return;
    const menu = screen.closest('salut-mmenu');
    if (!menu) return;
    const lazy = window.SalutMmenuLazy;
    mount(screen, lazy.sectionUrl(menu, screen), 'SalutBrandLetter-').catch(() => lazy.fail(screen));
  });

  window.SalutMenuBrands = { mount: mount };
})();
